import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { DetailViewComponent } from '../../detail-view.component';

// text,email,tel,textarea,password,
@Component({
    selector: 'field-divider',
    templateUrl: './field-divider.component.html',
    styleUrls: ['./field-divider.component.scss'],
    standalone: false
})
export class FieldDividerComponent implements OnInit, OnDestroy {
  @Input() prop: any = {};
  @Input() viewExpanded: boolean;

  constructor(public detailViewComponent: DetailViewComponent) {}

  ngOnInit() {}

  ngOnDestroy() {}
}
